const createLogMethod =
	(level) =>
	(...args) => {
		console[level](`[${level}]:`, ...args); // eslint-disable-line no-console
	};

const shimLogger = {
	bindings: () => ({}),

	// Common pino methods
	child: () => shimLogger,

	debug: createLogMethod('debug'),

	error: createLogMethod('error'),

	fatal: createLogMethod('error'),

	flush: () => Promise.resolve(),

	info: createLogMethod('info'),

	level: '',

	// Other common logger methods
	log: createLogMethod('log'),

	setBindings: () => shimLogger,

	silent: () => shimLogger,

	// Standard log levels
	trace: createLogMethod('trace'),

	warn: createLogMethod('warn'),

	// Context methods for chainability
	with: () => shimLogger,
	withContext: () => shimLogger,
};

export const stdSerializers = {
	err: createLogMethod('error'),
};

export default () => {
	if (process.env.NODE_ENV === 'development') {
		console.warn('🚨 Using pinoShim in the client - real logging disabled 🚨'); // eslint-disable-line no-console
	}

	return shimLogger;
};
